// @flow

import type { Action } from 'app/common/redux/types';
import type { NuxStep } from 'app/common/redux/actions/nuxProgress';

export type State = {
  step: ?NuxStep,
};

const initialState = {
  step: 'welcome',
};

const nuxProgress = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'SET_NUX_PROGRESS':
      return {
        ...state,
        step: action.payload.step,
      };
    default:
      return state;
  }
};

export default nuxProgress;
